import {
  CustomerMeetingAccount,
  CustomerMeetingAccountState,
} from '@libs/focus-frontend-types/src/@teamleader/api/customerMeetingAccounts';
import {
  CustomerMeetingUser,
  CustomerMeetingUserAccess,
  CustomerMeetingUserState,
} from '@libs/focus-frontend-types/src/@teamleader/api/customerMeetingUsers';

const isAccessibleForAccount = (customerMeetingAccountInfo?: CustomerMeetingAccount | null) => {
  if (!customerMeetingAccountInfo) {
    return false;
  }

  const { state: accountState } = customerMeetingAccountInfo;

  return accountState !== CustomerMeetingAccountState.NotActivated;
};

const isAccessibleForUser = (
  customerMeetingAccountInfo?: CustomerMeetingAccount | null,
  customerMeetingUserInfo?: CustomerMeetingUser | null,
) => {
  if (!customerMeetingAccountInfo || !customerMeetingUserInfo) {
    return false;
  }

  const accessibleForAccount = isAccessibleForAccount(customerMeetingAccountInfo);
  const { permission: userPermission } = customerMeetingUserInfo;

  return accessibleForAccount && userPermission === CustomerMeetingUserAccess.Access;
};

const isActiveForUser = (
  customerMeetingAccountInfo?: CustomerMeetingAccount | null,
  customerMeetingUserInfo?: CustomerMeetingUser | null,
) => {
  if (!customerMeetingAccountInfo || !customerMeetingUserInfo) {
    return false;
  }

  const accessibleForUser = isAccessibleForUser(customerMeetingAccountInfo, customerMeetingUserInfo);
  const { state: userState } = customerMeetingUserInfo;

  return accessibleForUser && userState === CustomerMeetingUserState.Active;
};

export interface CustomerMeetingService {
  isAccessibleForAccount: (customerMeetingAccountInfo?: CustomerMeetingAccount | null) => boolean;
  isAccessibleForUser: (
    customerMeetingAccountInfo?: CustomerMeetingAccount | null,
    customerMeetingUserInfo?: CustomerMeetingUser | null,
  ) => boolean;
  isActiveForUser: (
    customerMeetingAccountInfo?: CustomerMeetingAccount | null,
    customerMeetingUserInfo?: CustomerMeetingUser | null,
  ) => boolean;
}

const customerMeetingService: CustomerMeetingService = {
  isAccessibleForAccount,
  isAccessibleForUser,
  isActiveForUser,
};

export default customerMeetingService;
